import gql from "fraql";
// This only exists because AppSelectContact and AppBilliongContactForm would be importing each other in loop.
// In other words at least this works in storybook.
export default {
    contactFields: gql `
    fragment _ on Contact {
      contactType
      contactableType
      personId

      name
      firstName
      lastName

      addressText
      addressHouse
      addressCity
      addressIndex
      addressState
      addressBox
      addressCountryId
      addressCountry @client {
        id
        name
        ioc
        alpha2
      }

      registryCountryId
      registryCountry @client {
        id
        name
        ioc
        alpha2
      }

      organisationName
      vatCode
      legalFormId

      billingEmail
    }
  `
};
